export default "__VITE_ASSET__D4g9wXa___"